"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
const statistics = [{
  id: 2,
  value: "30-40%",
  label: "Reduction in non-billable contractor idle time"
}, {
  id: 3,
  value: "0%",
  label: "Retainers or hidden management overheads"
}, {
  id: 4,
  value: "100%",
  label: "Outcome-based delivery with milestone payments"
}];
export default function KeyStatistics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}